<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="700"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="车牌号">
                <a-input placeholder="请输入车牌号" v-decorator.trim="['plateNumber', validatorRules.plateNumber]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌">
                <a-input placeholder="请输入品牌" v-decorator.trim="['brand', validatorRules.brand]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号">
                <a-input placeholder="请输入型号" v-decorator.trim="['model', validatorRules.model]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="颜色">
                <a-input placeholder="请输入颜色" v-decorator.trim="['color']" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="车辆类型">
                <a-select placeholder="请选择车辆类型" v-decorator="['vehicleType']">
                  <a-select-option value="sedan">轿车</a-select-option>
                  <a-select-option value="suv">SUV</a-select-option>
                  <a-select-option value="truck">货车</a-select-option>
                  <a-select-option value="bus">客车</a-select-option>
                  <a-select-option value="other">其他</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                <a-select placeholder="请选择状态" v-decorator="['status', validatorRules.status]">
                  <a-select-option value="idle">空闲</a-select-option>
                  <a-select-option value="using">使用中</a-select-option>
                  <a-select-option value="repair">维修</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-textarea placeholder="请输入备注" v-decorator="['remark']" :rows="3" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { create, update } from '@/api/plugin/vehicle'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: "VehicleModal",
  mixins: [mixinDevice],
  data() {
    return {
      title: "操作",
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        plateNumber: {
          rules: [
            { required: true, message: '请输入车牌号!' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
          ]
        },
        brand: {
          rules: [
            { required: true, message: '请输入品牌!' }
          ]
        },
        model: {
          rules: [
            { required: true, message: '请输入型号!' }
          ]
        },
        status: {
          rules: [
            { required: true, message: '请选择状态!' }
          ]
        }
      },
    }
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'plateNumber', 'brand', 'model', 'color', 'vehicleType', 'status', 'remark'))
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(this.model, values);
          let obj;
          if (!this.model.id) {
            obj = create(formData);
          } else {
            obj = update(formData);
          }
          obj.then((res) => {
            if (res.code === 200) {
              that.$emit('ok');
            } else {
              that.$message.warning(res.data.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped>
</style>
